import { defineNuxtPlugin } from 'nuxt/app';
import type { App, DirectiveBinding } from 'vue';

const imageBind = (el: HTMLImageElement, binding: DirectiveBinding<string>) => {
  el.onerror = null;
  el.onerror = () => {
    el.src = binding.value;
    el.onerror = null;
  };
};

export default defineNuxtPlugin(({ vueApp }: { vueApp: App }) => {
  vueApp.directive('image-fallback', {
    mounted(el: HTMLImageElement, binding: DirectiveBinding<string>) {
      imageBind(el, binding);
    },
    updated(el: HTMLImageElement, binding: DirectiveBinding<string>) {
      imageBind(el, binding);
    },
    unmounted(el: HTMLImageElement) {
      el.onerror = null;
    }
  });
});
